import { GT_Invoice } from '../../types/invoices'
import ClickEvent = JQuery.ClickEvent;
import { SQL_Date } from '../../types/globals'
import { DateTime } from 'luxon'
import SubmitEvent = JQuery.SubmitEvent
import { Toast } from '@app/utils/toast'

export abstract class Invoices_Controller {}

export class Project_Invoices_Controller extends Invoices_Controller {
    invoices: GT_Invoice[]
    action_container: HTMLDivElement|null = null

    constructor( invoices: GT_Invoice[] = [] )  {
        super()
        this.invoices = invoices
    }

    ready() {
        this.set_action_container()
        this.render_invoices()

        this.init_actions()
        this.init_events()
        this.init_forms()
        this.init_calendars()
    }

    set_invoices( data: GT_Invoice[] = [] ) {
        console.debug( 'set invoices', data )
        this.invoices = data
    }

    set_action_container() {
        this.action_container = document.querySelector( '.action-container[data-post-type="invoice"]' )
    }

    get_action_container() {
        if ( ! this.action_container ) {
            throw new Error ( 'kein Action Container' )
        }

        return this.action_container
    }

    init_actions() {
        jQuery( 'button[data-action="add-invoice"]' ).on( 'click', () => this.init_modal_add_invoice() )
        jQuery( 'form [data-action="delete-invoice"]' ).on( 'click', () => this.delete_invoice_confirmation() )
    }

    init_events() {
        jQuery( '.item-list', this.get_action_container() ).on(
            'click',
            ( e: ClickEvent ): void => {
                const target: HTMLElement|null = e.target.closest( '.list-item' )

                if ( target == null ) {
                    return
                }

                if ( 'debug' in e.target.dataset ) {
                    return
                }

                if ( e.target.dataset.action === 'update-invoice' ) {
                    this.init_modal_update_invoice( target )
                    return
                }

                target.classList.toggle( 'collapsed' )
            }
        )
    }

    init_forms() {
        jQuery( '#form-add-invoice' ).form(
            {
                errorFocus: false,
                revalidate: true,

                // @ts-expect-error Overload.
                onSuccess: ( e: SubmitEvent ) => this.ajax_add_invoice( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
                fields: {
                    'invoice-category-add': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Kategorie angeben.'
                            }
                        ]
                    },
                    'invoice-amount-add': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte einen Betrag für die Rechnung angeben.'
                            },
                            {
                                type: 'integer',
                                prompt: 'Bitte einen vollen Eurobetrag ohne Cents als Betrag angeben.'
                            }
                        ]
                    },
                    'invoice-payment-date-add': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte ein Datum definieren.'
                            }
                        ]
                    }
                }
            }
        )

        jQuery( '#form-update-invoice' ).form(
            {
                errorFocus: false,
                revalidate: true,

                // @ts-expect-error Overload.
                onSuccess: ( e: SubmitEvent ) => this.ajax_update_invoice( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
                fields: {
                    'invoice-category-update': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Kategorie angeben.'
                            }
                        ]
                    },
                    'invoice-amount-update': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte einen Betrag für die Rechnung angeben.'
                            },
                            {
                                type: 'integer',
                                prompt: 'Bitte einen vollen Eurobetrag ohne Cents als Betrag angeben.'
                            }
                        ]
                    },
                    'invoice-payment-date-update': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte ein Datum definieren.'
                            }
                        ]
                    }
                }
            }
        )
    }

    init_calendars() {
        jQuery( '#date-invoice-payment-date-add, #date-invoice-payment-date-update' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    showWeekNumbers: true,
                    monthFirst: false,
                    formatter: {
                        date: 'DD.MM.YYYY',
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                }
            );
    }

    init_modal_add_invoice() {
        console.log( 'init modal: add invoice' )

        const modal  = jQuery( '[data-modal="add-invoice"]' )
        const form   = jQuery( 'form', modal )

        // resets.
        form.form( 'reset' )

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    ajax_add_invoice( e: SubmitEvent ) {
        console.log( 'add invoice', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget as HTMLElement )

        const submit = jQuery( '.submit', form )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { ajax_url, post_id, nonce } = gt_ajax_object

        const data = {
            action: 'add_invoice',
            form_data: form.serialize(),
            post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_invoices( response.invoices )

                // @ts-expect-error aus meta.js
                update_meta_list_item( 'project-total-invoiced-amount', response.updated_total )
                this.render_invoices()

                app.close_modals()
            }
        )
    }

    init_modal_update_invoice( target: HTMLElement ) {
        console.log( 'init modal: update invoice', target )

        const modal    = jQuery( '[data-modal="update-invoice"]' )
        const form     = jQuery( '#form-update-invoice' )
        const post_id: number  = Number( target.dataset.postId )
        const invoice: GT_Invoice|undefined = this.invoices.find( ( el: GT_Invoice ): boolean => el.post_id === post_id )

        if ( ! invoice ) {
            return
        }

        // resets
        form.find( 'input[name="invoice-post-id"' ).val( post_id )

        // sets
        jQuery( `input[name="invoice-category-update"][value="${invoice.category.slug}"]` ).closest( '.ui.checkbox' ).checkbox( 'check' )
        jQuery( '#invoice-comment-update' ).val( invoice.comment )
        jQuery( '#invoice-amount-update' ).val( invoice.amount )
        jQuery( '#date-invoice-payment-date-update' ).calendar( 'set date', invoice.payment_date )

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    ajax_update_invoice( e: SubmitEvent ) {
        console.log( 'update invoice', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget as HTMLElement )

        const submit = jQuery( '.submit', form )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { ajax_url, post_id, nonce } = gt_ajax_object

        const data = {
            action: 'update_invoice',
            form_data: form.serialize(),
            post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_invoices( response.invoices )

                // @ts-expect-error aus meta.js
                update_meta_list_item( 'project-total-invoiced-amount', response.updated_total )
                this.render_invoices()

                app.close_modals()
            }
        );
    }

    delete_invoice_confirmation() {
        const form = jQuery( '#form-update-invoice' )
        const post_id = form.find( '[name="invoice-post-id"]' ).val() as string

        if ( ! post_id ) {
            return
        }

        console.log( 'delete invoice?', post_id )

        const confirmation = app.get_modal( 'delete-invoice-confirmation' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved', post_id )
                    this.ajax_delete_invoice( post_id )
                }
            }
        )
        confirmation.modal( 'show' )
    }

    ajax_delete_invoice( invoice_post_id: string ) {
        console.log( 'delete invoice', invoice_post_id )

        if ( ! invoice_post_id ) {
            return
        }

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_invoice',
            post_id,
            invoice_post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_invoices( response.invoices )

                // @ts-expect-error aus meta.js
                update_meta_list_item( 'project-total-invoiced-amount', response.updated_total )
                this.render_invoices()

                app.close_modals()
            }
        )
    }

    sort_sql_date( a: SQL_Date, b: SQL_Date ): 1|-1|0 {
        const keyA: DateTime = DateTime.fromSQL( a )
        const keyB: DateTime = DateTime.fromSQL( b )

        if ( keyA > keyB ) {
            return 1
        }

        if ( keyA < keyB ) {
            return -1
        }

        return 0
    }

    render_invoices() {
        console.debug( 'render invoices', this.invoices.length )

        const items: GT_Invoice[] = this.invoices
        const value: HTMLElement|null = this.get_action_container().querySelector( '.header-data .value' )

        const list_container: HTMLUListElement|null = this.get_action_container().querySelector( '.item-list' )
        const total: number  = items.length

        if ( ! list_container || ! value ) {
            return
        }

        list_container.innerHTML = ''

        const total_amount = this.calculate_project_total_amount()

        value.innerHTML = `${total_amount} €`

        if ( total > 0 ) {
            const sorted = items.sort( ( a: GT_Invoice, b: GT_Invoice ): 1|-1|0 => this.sort_sql_date( a.payment_date, b.payment_date ) )

            for ( const item of sorted ) {
                const li: HTMLLIElement = document.createElement( 'li' )

                li.classList.add( 'list-item', 'invoice-item', 'can-toggle', 'collapsed' )
                li.dataset.postId = item.post_id.toString()

                li.innerHTML = `
				<div class="item-title">
					<div class="title">${item.category.name}</div>
					
					<div class="content">
						<div class="comment">${item.comment}</div>
					</div>
					
					<div class="details"></div>
				</div>
							
				<div class="item-date">
				    <span class="value"><i class="calendar alternate outline icon"></i> ${format_date( item.payment_date )}</span>
                </div>
                
				<div class="item-info">
				    <span class="value">${item.amount} €</span>
                </div>
				
				<div class="item-icon angle">
					<i class="angle left icon"></i>
				</div>

                <div class="item-actions">
					<a class="ui tiny primary button debug" href="/wp-admin/post.php?post=${item.post_id}&action=edit" 
					target="_blank" data-debug data-hidden="${( gt_user_settings.enable_debug === '1' ? 'false' : 'true' )}">Post bearbeiten</a>

					<button class="ui tiny button" data-action="update-invoice">
						bearbeiten
					</button>
				</div>	`

                list_container.append( li )
            }
        }
    }

    calculate_project_total_amount(): number {
        return this.invoices.reduce(
            ( accumulator: number, currentValue: GT_Invoice ): number => accumulator + currentValue.amount,
            0,
        )
    }

    update_project_total_amount() {

    }
}

export class List_Invoices_Controller extends Invoices_Controller {

}
